import React from "react";

function IrlFlag() {
  return (
    <div>
      <svg
        className="icon-sm"
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        xlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 473.684 473.684"
        style={{ width: "40px", height: "40px" }}
        space="preserve"
      >
        <path
          style={{ fill: "#F27021" }}
          d="M315.802,13.535l-27.639,76.632c25.512,84.193,25.512,209.156,0,293.353l27.639,76.624
	c91.975-32.523,157.882-120.195,157.882-223.31C473.684,133.736,407.777,46.059,315.802,13.535z"
        />
        <g>
          <path
            style={{ fill: "#E4E4E4" }}
            d="M315.802,90.167V13.535C291.102,4.8,264.536,0.002,236.84,0.002
		C273.361,0.002,222.723,123.775,315.802,90.167z"
          />
          <path
            style={{ fill: "#E4E4E4" }}
            d="M236.84,473.682c27.695,0,54.262-4.798,78.962-13.534v-76.624
		C223.658,374.328,236.84,473.682,236.84,473.682z"
          />
        </g>
        <path
          style={{ fill: "#2DB24A" }}
          d="M0,236.837c0,103.46,66.355,191.363,158.806,223.624V13.229C66.355,45.49,0,133.393,0,236.837z"
        />
        <path
          style={{ fill: "#F69338" }}
          d="M315.802,90.167V383.52C341.317,299.323,341.317,174.36,315.802,90.167z"
        />
        <path
          style={{ fill: "#F3F4F5" }}
          d="M315.802,383.523V90.167C299.677,36.938,273.361,0.002,236.84,0.002
	c-27.351,0-53.592,4.697-78.034,13.227v447.234c24.442,8.53,50.683,13.22,78.034,13.22
	C273.361,473.682,299.677,436.746,315.802,383.523z"
        />
      </svg>
    </div>
  );
}
export default IrlFlag;
